import { render, staticRenderFns } from "./registrationSystemPersonnel.vue?vue&type=template&id=0650aed9&scoped=true&"
import script from "./registrationSystemPersonnel.vue?vue&type=script&lang=js&"
export * from "./registrationSystemPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650aed9",
  null
  
)

export default component.exports